import { c as _c } from "react/compiler-runtime";
import Button from "src/components/button/Button";
import LabelledCheck from "src/components/labelledcheck/LabelledCheck";
import SelectorWrapper from 'src/components/selectorwrapper/SelectorWrapper';
import type { StreamingProvider } from 'src/lib/movieinfo/movieinfotypes';
import { type ActionType, type IStreamingGenre, type IStreamingReleasesFilterState, STREAMING_GENRES } from 'src/lib/streaming/StreamingReleasesFilter';
import classNames from 'classnames';
import styles from './Filter.module.css';
import { uniqBy } from "lodash";
import { useState } from "react";

//#region [Props]
type FilterProps = {
  streamingProviders: StreamingProvider[];
  filterDispatch: React.Dispatch<ActionType>;
  filterState: IStreamingReleasesFilterState;
};
//#endregion

//#region [Component]
export default function Filter(t0) {
  const $ = _c(34);
  const {
    streamingProviders,
    filterDispatch,
    filterState
  } = t0;
  const [selectedGenres, setSelectedGenres] = useState(filterState.selectedGenres);
  const [selectedProviders, setSelectedProviders] = useState(filterState.selectedProviders);
  let t1;
  if ($[0] !== filterDispatch) {
    t1 = () => filterDispatch({
      type: "hide"
    });
    $[0] = filterDispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles.SScrollContainer);
    t3 = classNames(styles.SFilterBlock);
    t4 = <h3 className={classNames(styles.SFilterBlockTitle)}>Sjangere</h3>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames(styles.SLabelledCheck);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = selectedGenres.length === 0;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setSelectedGenres([]);
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6) {
    t8 = <LabelledCheck className={t5} selected={t6} selectionCallback={t7} value="Alle" />;
    $[7] = t6;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== selectedGenres) {
    t9 = STREAMING_GENRES.map(genre => <LabelledCheck className={classNames(styles.SLabelledCheck)} key={genre.id} value={genre.id} label={genre.name} selected={selectedGenres.includes(genre)} selectionCallback={isSelected => selectGenre(setSelectedGenres, selectedGenres, isSelected, genre)} />);
    $[9] = selectedGenres;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <div className={t3}>{t4}{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== selectedProviders || $[15] !== streamingProviders) {
    t11 = (streamingProviders?.length ?? 0) > 0 && <div className={classNames(styles.SFilterBlock)}><h3 className={classNames(styles.SFilterBlockTitle)}>Streamingtjenester</h3><LabelledCheck className={classNames(styles.SLabelledCheck)} selected={selectedProviders.length === 0} selectionCallback={() => setSelectedProviders([])} value="Alle" />{streamingProviders.map(provider => <LabelledCheck className={classNames(styles.SLabelledCheck)} key={provider.id} selected={selectedProviders.includes(provider)} value={provider.id} label={provider.name} selectionCallback={isSelected_0 => selectProvider(setSelectedProviders, selectedProviders, isSelected_0, provider)} />)}</div>;
    $[14] = selectedProviders;
    $[15] = streamingProviders;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <div className={t2}>{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = classNames(styles.SControls);
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== filterDispatch || $[22] !== selectedGenres || $[23] !== selectedProviders) {
    t14 = <Button text="Vis" onClick={() => filterDispatch({
      type: "applyFilter",
      selectedGenres,
      selectedProviders
    })} />;
    $[21] = filterDispatch;
    $[22] = selectedGenres;
    $[23] = selectedProviders;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== filterDispatch) {
    t15 = <Button text="Avbryt" onClick={() => filterDispatch({
      type: "hide"
    })} />;
    $[25] = filterDispatch;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <div className={t13}>{t14}{t15}</div>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t1 || $[31] !== t12 || $[32] !== t16) {
    t17 = <SelectorWrapper onClose={t1} heading="Valg">{t12}{t16}</SelectorWrapper>;
    $[30] = t1;
    $[31] = t12;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}
//#endregion

//#region [Other]
function selectGenre(setSelectedGenres: (providers: IStreamingGenre[]) => void, currGenres: IStreamingGenre[], isSelected: boolean, value: IStreamingGenre) {
  if (isSelected) {
    setSelectedGenres(uniqBy([...currGenres, value], g => g.id));
  } else {
    setSelectedGenres(currGenres.filter(g => g !== value));
  }
}
function selectProvider(setSelectedProviders: (providers: StreamingProvider[]) => void, currProviders: StreamingProvider[], isSelected: boolean, value: StreamingProvider) {
  if (isSelected) {
    setSelectedProviders(uniqBy([...currProviders, value], p => p.id));
  } else {
    setSelectedProviders(currProviders.filter(p => p.id !== value.id));
  }
}
//#endregion

//#region [Styles]
//#endregion